import { Box, Typography, Stack, Checkbox } from "@mui/material";
import { useCallback } from "react";
const DEVICES = [
  { value: '2', label: 'Desktop' },
  { value: '3', label: 'Phone' },
  { value: '4', label: 'Tablet' },
  { value: '6', label: 'TV' },
];

export const DevicesSelect = ({ devices, handleFormChange, friendly = false }: Props) => {

  // Обработчик устройств
  const handleDevice = useCallback(
    (value: string) => {
      const newDevices = devices.includes(value)
        ? devices.filter(item => item !== value)
        : [...devices, value];
      handleFormChange('devices', newDevices);
    },
    [devices, handleFormChange],
  );

  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      <Typography fontWeight={600} variant="subtitle2">Устройства:</Typography>
      <Stack direction="row" gap={0.5}>
        {DEVICES.map(device => {
          const value = friendly ? device.label.toLowerCase() : device.value;
          return (
            <Box key={device.value}>
              <label>{device.label}</label>
              <Checkbox
                value={value}
                checked={devices.includes(value)}
                onChange={() => handleDevice(value)} />
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
}